var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmitted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "#0085FF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5.4399C7 5.19722 7.19673 5.00049 7.43941 5.00049H16.1242C16.3668 5.00049 16.5636 5.19722 16.5636 5.4399C16.5636 5.68257 16.3668 5.8793 16.1242 5.8793H7.43941C7.19673 5.8793 7 5.68257 7 5.4399Z",
    fill: "#0085FF",
    stroke: "#0085FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87891 5.43941C7.87891 5.19673 8.07564 5 8.31831 5H15.3488C15.5915 5 15.7882 5.19673 15.7882 5.43941V7.5675C15.7882 8.91627 15.1103 10.1752 13.9797 10.9484L13.2489 11.4481C12.9938 11.6226 12.9938 11.999 13.2489 12.1735L13.9797 12.6732C15.1103 13.4464 15.7882 14.7053 15.7882 16.0541V18.1822C15.7882 18.4249 15.5915 18.6216 15.3488 18.6216H8.31831C8.07564 18.6216 7.87891 18.4249 7.87891 18.1822V16.0541C7.87891 14.7053 8.55684 13.4464 9.68745 12.6732L10.4182 12.1735C10.6734 11.999 10.6734 11.6226 10.4182 11.4481L9.68745 10.9484C8.55684 10.1752 7.87891 8.91627 7.87891 7.5675V5.43941ZM8.75772 5.87881V7.5675C8.75772 8.6177 9.2854 9.60881 10.1835 10.223L10.9143 10.7227C11.6798 11.2462 11.6798 12.3755 10.9143 12.8989L10.1835 13.3986C9.2854 14.0128 8.75772 15.0039 8.75772 16.0541V17.7428H14.9094V16.0541C14.9094 15.0039 14.3817 14.0128 13.4836 13.3986L12.7529 12.8989C11.9874 12.3755 11.9874 11.2462 12.7529 10.7227L13.4836 10.223C14.3817 9.60881 14.9094 8.6177 14.9094 7.5675V5.87881H8.75772Z",
    fill: "#0085FF",
    stroke: "#0085FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 18.1822C7 18.4249 7.19673 18.6216 7.43941 18.6216H16.1242C16.3668 18.6216 16.5636 18.4249 16.5636 18.1822C16.5636 17.9395 16.3668 17.7428 16.1242 17.7428H7.43941C7.19673 17.7428 7 17.9395 7 18.1822Z",
    fill: "#0085FF",
    stroke: "#0085FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitted);
export default __webpack_public_path__ + "static/media/Submitted.f422d7e6c5463a8a68d0dad3ea2a87f3.svg";
export { ForwardRef as ReactComponent };